import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { login as loginApi, logout as logoutApi, currentUser } from '@/api/auth';
import type { LoginBody } from '@/api/auth';
import type { SessionUser } from '@/types';

export function useCurrentUser() {
  return useQuery({
    queryKey: ['auth', 'user'],
    queryFn: currentUser,
    staleTime: 60_000,
    retry: false,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: LoginBody) => loginApi(body),
    onSuccess: (user: SessionUser) => {
      qc.setQueryData(['auth', 'user'], user);
    },
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: logoutApi,
    onSuccess: () => {
      qc.setQueryData(['auth', 'user'], null);
      void qc.clear();
    },
  });
}
